var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tagListingFilterGroups.length > 0)?_c('section',{staticClass:"tag-listing-filters"},[_c('div',{staticClass:"tag-listing-filters-wrapper"},[(_vm.tagListingFilterGroups.length > 0)?_c('BaseGroupListingFilters',{attrs:{"base-group-combos":_vm.tagListingFilterGroups}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }